/**
 * Actions for Create Event
 */
export enum serviceOperationActions {
  SAVE_SERVICE_OPERATIONS = 'SAVE_SERVICE_OPERATIONS',
  CLEAR_SERVICE_OPERATIONS = 'CLEAR_SERVICE_OPERATIONS',
  DELETE_SERVICE_OPERATION = 'DELETE_SERVICE_OPERATION',
  UPDATE_SERVICE_OPERATION = 'UPDATE_SERVICE_OPERATION'
}
